import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, signal, afterNextRender, OnChanges, SimpleChanges } from '@angular/core';

export interface ILiberroSelectOption {
  label: string | number;
  value: string | number;
  disabled?: boolean;
}

@Component({
  selector: 'liberro-select',
  templateUrl: './liberro-select.component.html',
  styleUrl: './liberro-select.component.less',
  standalone: false,
})
export class LiberroSelectComponent implements OnChanges {
  @ViewChild('selectElement') private selectElement!: ElementRef;

  @Input() public placeholder = '';
  @Input() public label = '';
  @Input({ required: true }) public value: number | string = '';
  @Input({ required: true }) public options: ILiberroSelectOption[] = [];
  @Input() public disabled = false;
  @Input() public customWidth = '';
  @Input() public suffixNzIcon = '';
  @Input() public suffixImgIcon = '';
  @Input() public prefix = '';
  @Input() public widthType: 'responsive' | null = null;

  @Output() public valueChange = new EventEmitter<number | string>();
  @Output() public openChange = new EventEmitter<boolean>();

  public displayText = signal<string>('');

  public constructor() {
    afterNextRender(() => this.computeDisplayText());
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] || changes['options'] || changes['prefix']) {
      this.computeDisplayText();
    }
  }

  public onValueChange(selectedValue: number | string): void {
    this.value = selectedValue;
    this.computeDisplayText();
    this.valueChange.emit(selectedValue);
  }

  public onOpenChange(isOpen: boolean): void {
    this.openChange.emit(isOpen);
  }

  private computeDisplayText(): void {
    if (!this.value) {
      this.displayText.set(this.placeholder);
      return;
    }

    const selectedOption = this.options.find(opt => opt.value === this.value);
    if (selectedOption) {
      const label = String(selectedOption.label);
      this.displayText.set(this.prefix ? `${this.prefix}: ${label}` : label);
    } else {
      this.displayText.set(this.placeholder);
    }
  }
}
